// extracted by mini-css-extract-plugin
export default {"youtubeRoot":"Kq-hN","youtubeIframe":"DG2iU","modalDialog":"PGmiV","modalContent":"uuh5s","closeVideoButton":"DS7Zp","closeIcon":"_1teYu"};